const userDataFormPT = {
    "view": {
        "title": "Complete suas Informações",
        "stepZero": {
            "title": "Declaração",
            "form": {
                "label": {
                    "declarationPoint1": "Ao fornecer estas informações, você reconhece e concorda que elas serão fornecidas ao melhor do seu conhecimento e capacidade. Nos esforçamos para garantir que todas as informações sejam precisas e verdadeiras.",
                    "declarationPoint2": "Esteja ciente de que fornecer informações falsas ou representar a verdade de forma incorreta pode ter consequências significativas. Instamos todos os usuários a verificarem as informações que fornecem e a usarem esta plataforma de forma responsável.",
                    "declarationPoint3": "A responsabilidade por qualquer desinformação ou erro recai exclusivamente sobre o indivíduo que fornece as informações. Não assumimos responsabilidade pelas consequências de informações incorretas ou enganosas fornecidas pelos usuários.",
                    "declarationPoint4": "Ao clicar em <strong>'Próximo'</strong>, você consente com estes termos e afirma que está totalmente ciente das implicações de fornecer informações imprecisas ou falsas.",
                    "declarationAgreement": "Eu concordo plenamente e entendo os termos acima."
                },
                "button": {
                    "next": "Próximo"
                }
            }
        },
        "stepOne": {
            "title": "Informações Pessoais",
            "form": {
                "label": {
                    "firstName": "Nome",
                    "lastName": "Sobrenome",
                    "streetAndNumber": "Rua e Número",
                    "zipCode": "CEP",
                    "city": "Cidade",
                    "country": "País"
                },
                "placeholder": {
                    "country": "Selecione o País"
                },
                "help_text": {
                    "firstName": "Se registrando como uma LLC ou outra entidade comercial, este campo será usado para o Nome do CEO.",
                    "lastName": "Se registrando como uma LLC ou outra entidade comercial, este campo será usado para o Sobrenome do CEO.",
                    "country": "Se registrando como uma LLC ou outra entidade comercial, este campo será usado para o País do CEO."
                },
                "button": {
                    "next": "Próximo"
                }
            }
        },
        "stepTwo": {
            "title": "Informações Comerciais",
            "form": {
                "label": {
                    "businessType": "Tipo de Negócio",
                    "companyName": "Nome da Empresa",
                    "businessStreet": "Rua e Número",
                    "businessCity": "Cidade",
                    "businessZip": "CEP",
                    "businessCountry": "País",
                    "ceoFirstName": "Representante Legal / Nome do CEO",
                    "ceoLastName": "Representante Legal / Sobrenome do CEO",
                    "tradeRegistryExport": "Exportação do Registro Comercial",
                    "tradeRegistryCompanyUrl": "URL da Empresa no Registro Comercial",
                    "vatNumber": "Número de IVA",
                    "taxNumber": "Número de Imposto"
                },
                "option": {
                    "businessType": {
                        "soleProprietorship": "Empresário Individual",
                        "limitedLiabilityCompany": "Sociedade de Responsabilidade Limitada",
                        "partnershipOrganized": "Sociedade Organizada",
                        "publicLimitedCompanyByShares": "Sociedade Anônima por Ações",
                        "other": "Outro"
                    }
                },
                "placeholder": {
                    "businessType": "Selecione o Tipo de Negócio",
                    "businessCountry": "Selecione o País"
                },
                "help_text": {
                    "companyName": "O nome da empresa deve ser consistente com o que foi inicialmente submetido no Stripe. Altere apenas se for diferente do que foi inicialmente submetido.",
                    "tradeRegistryExport": "Por favor, forneça uma exportação oficial do registro comercial da sua empresa. Apenas PDF, tamanho máximo do arquivo 5 MB. Se precisar de ajuda para encontrar sua exportação do registro comercial, entre em contato com o registro em seu país. Uma lista não oficial dos registros pode ser encontrada <1>aqui</1>.",
                    "tradeRegistryCompanyUrl": "Por favor, forneça a URL da sua empresa no registro comercial do seu país. Se o seu registro não suportar isso, insira apenas uma URL do registro."
                },
                "button": {
                    "previous": "Anterior",
                    "next": "Próximo"
                }
            }
        },
        "stepThree": {
            "title": "Confirmação",
            "form": {
                "label": {
                    "personalInformation": "Informações Pessoais",
                    "personalName": "Nome",
                    "personalAddress": "Endereço",
                    "businessInformation": "Informações Comerciais",
                    "companyName": "Empresa",
                    "ceoName": "Nome do CEO",
                    "businessAddress": "Endereço",
                    "businessType": "Tipo de Negócio",
                    "taxNumber": "Número de Imposto",
                    "vatNumber": "Número de IVA",
                    "tradeRegistryExportUploaded": "Exportação do Registro Comercial Enviada",
                    "tradeRegistryCompanyUrl": "URL da Empresa no Registro Comercial",
                    "notAvailable": "N/D"
                },
                "button": {
                    "previous": "Anterior",
                    "save": "Salvar",
                    "next": "Próximo"
                }
            },
            "message": {
                "success": "Suas informações foram atualizadas!",
                "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
            },
            "modal": {
                "submitYourInformation": {
                    "header": "Envie Suas Informações",
                    "body": {
                        "point1": "Ao clicar em <strong>'Confirmar'</strong>, você está afirmando que todas as informações fornecidas são precisas e verdadeiras ao melhor do seu conhecimento.",
                        "point2": "Você confirma que todos os detalhes fornecidos estão corretos e reconhece as potenciais consequências de enviar informações imprecisas?"
                    },
                    "button": {
                        "confirm": "Confirmar",
                        "cancel": "Cancelar"
                    }
                }
            }
        },
        "stepFour": {
            "title": "Verificar Número de Celular",
            "form": {
                "label": {
                    "mobileNumber": "Digite Seu Número de Celular",
                    "deliveryMedium": "Meio de Entrega: ",
                    "deliveryMediumSMS": "SMS",
                    "deliveryMediumWhatsapp": "WhatsApp",
                    "otp": "OTP"
                },
                "help_text": {
                    "mobileNumber": "Nota: O Número de Celular é necessário para verificação como procedimento padrão porque pode ser usado para validação de login. Você precisa possuir o número e ter acesso a ele para um processo de verificação tranquilo.",
                    "isFormUSorCanada": "* Se você estiver nos EUA ou Canadá, entre em contato com nossa equipe de suporte após inserir seu número de celular.",
                    "deliveryMediumWhatsapp": "Nota: Certifique-se de que você tem uma conta WhatsApp neste número para receber a mensagem.",
                    "otp": "Por favor, insira o OTP enviado para o seu número de celular."
                },
                "message": {
                    "errorMobileNumberEmpty": "O Número de Celular é obrigatório.",
                    "errorMobileNumberInvalid": "Número de celular inválido.",
                    "errorMobileNumberSame": "Este número já foi adicionado e verificado com sua conta.",
                    "errorOTPRequired": "OTP é obrigatório.",
                    "errorOtpSendLimitExhasuted": "Você não pode solicitar mais OTPs, pois já esgotou o <strong>limite MÁXIMO ({{maxLimit}})</strong> de solicitações de OTP. Entre em contato com o suporte para mais informações!",
                    "errorMobileUpdateLimitExhausted": "Você não pode atualizar seu número de celular, pois já o atualizou o MÁXIMO ({{maxLimit}}) de vezes. Entre em contato com o suporte para mais informações!"
                },
                "button": {
                    "sendOTP": "Enviar OTP",
                    "next": "Próximo",
                    "confirm": "Confirmar",
                    "notGettingCode": "Não estou recebendo o código"
                }
            },
            "message": {
                "success": "Número de celular verificado!",
                "errorValidatingOTP": "Erro ao validar o OTP!",
                "errorSendingOTP": "Houve um problema ao enviar o código OTP, por favor, tente novamente mais tarde!"
            },
            "modal": {
                "notGettingCode": {
                    "header": "Não estou recebendo o código",
                    "body": {
                        "point1": "Parece que há um problema em enviar um código de verificação para você agora. Por favor, tente novamente mais tarde",
                        "point2": "Para assistência, entre em contato com nosso suporte via Central de Ajuda."
                    },
                    "button": {
                        "close": "Fechar"
                    }
                }
            },
            "resendTimer": {
                "message": {
                    "secondsRemaining": "Você pode solicitar o OTP novamente em <strong>{{secondsRemaining}}</strong> segundos"
                }
            }
        },
        "stepFive": {
            "title": "Verificação de Identidade",
            "form": {
                "label": {
                    "identityVerificationDescription": "Por favor, clique no link abaixo para iniciar a Verificação de Identidade.",
                    "identityVerificationResults": "Resultados da Verificação de Identidade"
                },
                "button": {
                    "loading": "Carregando...",
                    "verifyIdentity": "Verificar Identidade"
                },
                "table": {
                    "column": {
                        "type": "Tipo",
                        "status": "Status",
                        "details": "Detalhes"
                    },
                    "label": {
                        "selfieVerification": "Verificação de Selfie",
                        "documentVerification": "Verificação de Documento",
                        "verified": "Verificado",
                        "notVerified": "Não Verificado",
                        "notAvailable": "N/D"
                    }
                },
                "message": {
                    "identityVerificationSuccess": "Suas informações de identidade foram verificadas, nossa equipe revisará as informações de identidade e dará a aprovação final em 2-3 dias úteis.",
                    "identityVerificationFailed": "Suas informações de identidade não puderam ser verificadas, por favor, envie as informações novamente! Você tem apenas <strong>{{attemptsRemaining}}</strong> tentativa restante para verificar sua identidade.",
                    "identityVerificationMaxAttempts": "Você esgotou o número máximo de tentativas para Verificação de Identidade, entre em contato com o suporte para mais informações."
                }
            }
        },
        "stepSix": {
            "title": "Assinar Contrato",
            "form": {
                "label": {
                    "signContract": "Assinar Contrato"
                }
            }
        },
        "stepSeven": {
            "title": "Aprovação",
            "form": {
                "message": {
                    "approval": "Nossa equipe revisará todas as informações fornecidas por você e dará a aprovação final dentro de 3 dias úteis."
                }
            }
        }
    },
    "signRedirectPages": {
        "signSuccess": {
            "title": "Assinatura de Contrato Bem-Sucedida :)",
            "description": "Você assinou seu contrato com sucesso, o status será atualizado em sua conta em breve, por favor, atualize a página em alguns segundos."
        },
        "signLater": {
            "title": "Assinar Contrato Mais Tarde ...",
            "description": "Você escolheu assinar o contrato mais tarde, por favor, complete esta etapa o mais rápido possível para usufruir da distribuição."
        },
        "signDeclined": {
            "title": "Assinatura de Contrato Recusada :(",
            "description": "Você recusou assinar o contrato, isso atrasará o processo para habilitar a distribuição."
        },
        "signCompleted": {
            "title": "Assinatura de Contrato Concluída :)",
            "description": "Seu contrato foi finalizado, o status será atualizado em sua conta em breve, por favor, atualize a página em alguns segundos."
        }
    }
};

export default userDataFormPT;